// extracted by mini-css-extract-plugin
export default {"wrapper":"supportForm_wrapper__ca7dx","sendButtonWrapper":"supportForm_sendButtonWrapper__sisO3","successSection":"supportForm_successSection__PFl3B"};